import { render, staticRenderFns } from "./VueLoading.vue?vue&type=template&id=0f99be4a&"
import script from "./VueLoading.vue?vue&type=script&lang=js&"
export * from "./VueLoading.vue?vue&type=script&lang=js&"
import style0 from "./VueLoading.vue?vue&type=style&index=0&id=0f99be4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports